import React, { useState } from "react";
import DataTable from "react-data-table-component";
import PageSizeSelect from "components/PageSizeSelect/PageSizeSelect";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import GroupCalonNasabah from "./groupCalonNasabah";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { Dna } from "react-loader-spinner";
import { getAllCalonNasabah } from "stores";
import "./CalonNasabah.css";

function CalonNasabah() {
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  //   console.log(korcab, "KORCAB");
  const [listDataCalonNasabah, setListDataCalonNasabah] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [idCalonNasabah, setIdCalonNasabah] = React.useState("");
  const [sendVal, setSendVal] = React.useState("");

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    setPage(0);
    getAllCalonNasabah(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_NASABAH", data: false });
    setIdCalonNasabah(val._id);
    setSendVal(val);
    // dispatch({ type: "SET_KIRIM_DETAIL_NASABAH", data: val });
  };

  React.useEffect(() => {
    let tmp =
      korcab.listCalonNasabah.docs &&
      korcab.listCalonNasabah.docs.map((val) => {
        return {
          ...val,
          // marketingName: val.marketing?.nama || "",
          // marketingNopeg: val.marketing?.nopeg || "",
          action: (
            <div className="action-buttons-group">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Nasabah</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-detail-red"
                  aria-label={`Detail ${val.namaNasabah || "nasabah"}`}
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i className="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListDataCalonNasabah(tmp);
  }, [korcab.listCalonNasabah]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getTypeKunjungan = (status) => {
    switch (status) {
      case "Dinas":
        return {
          fontWeight: "bold",
          backgroundColor: "#DDF3F4",
          textColor: "#0C8990",
        };
      case "Personal":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFF6E6",
          textColor: "#FFA700",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    head: { style: { zIndex: 5 } },
    rows: {
      style: {
        minHeight: "68px",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "56px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "12px",
        color: "#ffffff",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#334155",
        padding: "14px 16px",
        lineHeight: "1.6",
      },
    },
  };

  const colKunjungan = [
    {
      id: "no",
      name: "No",
      width: "64px",
      center: true,
      // selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      selector: (row, index) =>
        index + (korcab.listCalonNasabah.pagingCounter || page * totalPerHalaman + 1),
    },
    {
      id: "nama-nasabah",
      name: "Nama Nasabah",
      width: "240px",
      wrap: true,
      style: { fontWeight: 600, color: "#0f172a" },
      selector: (row) => row.namaNasabah || "-",
    },
    {
      id: "nik",
      name: "NIK",
      width: "184px",
      center: true,
      style: { fontVariantNumeric: "tabular-nums" },
      selector: (row) => (!row.nik ? "-" : row.nik),
    },
    {
      name: "NIP",
      minWidth: "190px",
      center: true,
      style: { fontVariantNumeric: "tabular-nums" },
      selector: (row) => (!row.nip ? "-" : row.nip),
    },

    {
      name: "No Hp",
      minWidth: "170px",
      center: true,
      selector: (row) => row.noHp || "-",
    },
    {
      name: "Tgl Lahir",
      minWidth: "190px",
      center: true,
      selector: (row) =>
        row.tglLahir && moment(row.tglLahir).isValid()
          ? moment(row.tglLahir).format("DD MMMM YYYY")
          : "-",
    },
    {
      name: "Marketing On Going",
      minWidth: "260px",
      wrap: true,
      selector: (row) => (!row.marketing ? "-" : row.marketing.nama),
    },
    {
      name: "Nopeg Marketing",
      minWidth: "200px",
      center: true,
      selector: (row) => (!row.marketing ? "-" : row.marketing.nopeg),
    },
    {
      name: "Kategori Nasabah",
      minWidth: "220px",
      center: true,
      selector: (row) => row.kategoriNasabah,
      cell: (row) => {
        const label =
          row.kategoriNasabah === "1"
            ? "PNS Biasa"
            : row.kategoriNasabah === "2"
              ? "PNS Prapurna Bakti"
              : row.kategoriNasabah === "3"
                ? "Pensiunan"
                : row.kategoriNasabah === "4"
                  ? "PRA THT"
                  : "KPS (Kredit Pensiunan)";
        return (
          <span className="modern-badge-pill badge-kategori">{label}</span>
        );
      },
    },
    {
      name: "Tipe Kunjungan",
      minWidth: "180px",
      center: true,
      selector: (row) => row.typeKunjungan,
      cell: (row) => {
        const badgeClass =
          row.typeKunjungan === "Dinas"
            ? "badge-dinas"
            : row.typeKunjungan === "Personal"
              ? "badge-personal"
              : "badge-neutral";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {row.typeKunjungan || "-"}
          </span>
        );
      },
    },
    {
      id: "aksi",
      name: "Aksi",
      width: "80px",
      center: true,
      cell: (row) => row.action,
    },
  ];

  // Keep each row as wide as its columns so sticky cells stay within the row.
  customStyles.table = {
    style: {
      minWidth: listDataCalonNasabah?.length
        ? `${colKunjungan.reduce(
            (total, column) => total + parseInt(column.width || column.minWidth, 10),
            0,
          )}px`
        : "100%",
    },
  };

  React.useEffect(() => {
    setIsLoading(true);
    getAllCalonNasabah(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      {korcab.modalDetailNasabah ? (
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="nasabah-card">
                <Card.Header className="nasabah-card-header">
                  <div className="nasabah-header-content">
                    <div>
                      <Card.Title as="h3" className="nasabah-title">
                        Daftar Calon Nasabah
                      </Card.Title>
                      <div className="nasabah-subtitle">
                        Tinjau dan kelola seluruh pengajuan data calon nasabah
                        secara mendetail
                      </div>
                    </div>
                    <div className="nasabah-search">
                      <InputGroup className="search-input-group w-100">
                        <Form.Control
                          className="search-input-control"
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          placeholder="Nama Nasabah / NIK / NIP..."
                          aria-label="Cari nama nasabah, NIK, atau NIP"
                          onKeyDown={handleKeyDown}
                        />
                        {searchText && (
                          <InputGroup.Append>
                            <Button
                              className="search-clear-btn"
                              aria-label="Hapus pencarian"
                              onClick={handleClearSearch}
                            >
                              <i className="fas fa-times"></i>
                            </Button>
                          </InputGroup.Append>
                        )}
                        <InputGroup.Append>
                          <Button
                            className="search-submit-btn"
                            aria-label="Cari nasabah"
                            onClick={handleFilterChange}
                          >
                            <i className="fas fa-search"></i>
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="nasabah-card-body">
                  {isLoading ? (
                    <div
                      className="loader-container"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "30vh",
                      }}
                    >
                      <Dna
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="dna-loading"
                        wrapperStyle={{}}
                        wrapperClass="dna-wrapper"
                      />
                      <p className="text-muted mt-3">
                        Memuat data calon nasabah...
                      </p>
                    </div>
                  ) : (
                    <div className="nasabah-responsive-region">
                      <div className="nasabah-table-summary">
                        <div>
                          <span className="nasabah-table-summary-title">
                            Monitoring Calon Nasabah
                          </span>
                          <span className="nasabah-table-count">
                            {listDataCalonNasabah?.length || 0} data di halaman ini
                          </span>
                        </div>
                        <span className="nasabah-table-hint">
                          <i className="fas fa-arrows-alt-h" aria-hidden="true" />
                          Geser tabel untuk melihat detail lainnya
                        </span>
                      </div>
                      <div className="nasabah-table-frame">
                        <DataTable
                          className="calon-nasabah-table"
                          keyField="_id"
                          columns={colKunjungan}
                          data={listDataCalonNasabah || []}
                          customStyles={customStyles}
                          fixedHeader
                          fixedHeaderScrollHeight="65vh"
                          noDataComponent={
                            <div className="nasabah-table-empty">
                              Belum ada calon nasabah yang sesuai dengan pencarian.
                            </div>
                          }
                          paginationPerPage={totalPerHalaman}
                          progressPending={isLoading}
                        />
                      </div>
                      <div
                        className="nasabah-mobile-list"
                        aria-label="Daftar calon nasabah"
                      >
                        {listDataCalonNasabah?.length ? (
                          listDataCalonNasabah.map((row, index) => (
                            <article className="nasabah-mobile-card" key={row._id}>
                              <div className="nasabah-mobile-heading">
                                <span className="nasabah-mobile-number">
                                  {colKunjungan[0].selector(row, index)}
                                </span>
                                <h4>{row.namaNasabah || "-"}</h4>
                                {row.action}
                              </div>
                              <dl className="nasabah-mobile-details">
                                {colKunjungan
                                  .filter((column) =>
                                    !["no", "nama-nasabah", "aksi"].includes(column.id),
                                  )
                                  .map((column) => (
                                    <div key={column.name}>
                                      <dt>{column.name}</dt>
                                      <dd>
                                        {column.cell
                                          ? column.cell(row)
                                          : column.selector(row, index)}
                                      </dd>
                                    </div>
                                  ))}
                              </dl>
                            </article>
                          ))
                        ) : (
                          <div className="nasabah-table-empty">
                            Belum ada calon nasabah yang sesuai dengan pencarian.
                          </div>
                        )}
                      </div>
                      <div className="nasabah-pagination">
                        <Row className="align-items-center">
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0"
                          >
                            <span
                              style={{
                                fontWeight: "700",
                                color: "#64748b",
                                fontSize: "14px",
                                marginRight: "12px",
                              }}
                            >
                              Baris per halaman:
                            </span>
                            <div style={{ width: "110px" }}>
                              <PageSizeSelect
                                value={totalPerHalaman}
                                options={options}
                                onChange={handlePageSizeChange}
                              />
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-center justify-content-md-end"
                          >
                            <ReactPaginate
                              forcePage={page}
                              containerClassName="paginations"
                              previousClassName="pages-itemss-containers"
                              previousLinkClassName="pages-links-labelss"
                              nextClassName="pages-itemss-containers"
                              nextLinkClassName="pages-links-labelss"
                              breakClassName="pages-itemss-containers"
                              pageCount={
                                korcab.listCalonNasabah.totalPages || 1
                              }
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageLinkClassName="pages-links-labelss"
                              pageClassName="pages-itemss-containers"
                              activeClassName="activees"
                              activeLinkClassName="aactivess"
                              nextLabel=" > "
                              previousLabel=" < "
                              initialPage={page}
                              disableInitialCallback={true}
                              onPageChange={(val) => {
                                setPage(val.selected);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <GroupCalonNasabah data={idCalonNasabah} value={sendVal} />
        </>
      )}
    </>
  );
}

export default CalonNasabah;
